import type { CheckoutStep } from '@t/checkout.types';
import type { StepDescriptor } from './stepDescriptors.types';

// Data-only declaration of the Checkout flow: order (array position), label,
// saved-form field, and visibility rule per step. Step content components live
// in ./stepContent so store-side consumers never import React component trees.
export const STEP_DESCRIPTORS: readonly StepDescriptor[] = [
  { key: 'customer', label: 'Customer Information', formField: 'customerInfo' },
  { key: 'phone', label: 'Phone Number', formField: 'phoneInfo', skipWhen: (ctx) => !ctx.hasPhonePlan },
  { key: 'installation', label: 'Installation', formField: 'installationInfo', skipWhen: (ctx) => !ctx.hasInstallationRequired },
  { key: 'review', label: 'Product Review', formField: null },
];

const descriptorByKey = Object.fromEntries(STEP_DESCRIPTORS.map((d) => [d.key, d])) as Record<
  CheckoutStep,
  StepDescriptor
>;

export const getStepDescriptor = (key: CheckoutStep): StepDescriptor => descriptorByKey[key];
